import { FormattedMessage } from "react-intl";

// export const BASE_URL = "http://192.168.1.16:8000/"  //ashar local
// export const BASE_URL = "https://tbx4zr6n-8000.asse.devtunnels.ms/" //ashar ngrok
// export const BASE_URL = "https://argotec-staging-api.astutesoftwares00.com/" //staging
// export const BASE_URL = "https://argotec-dev-api.astutesoftwares00.com/" //development
export const BASE_URL = "https://api.argotecgroup.com/" // production 

export const CLIENT_DOMAIN = process.env.NODE_ENV === "production" ? "https://astute-ecom-demo.netlify.app/" : "http://192.168.18.176:3003/"
export const S3_BUCKET_LINK = "https://argotec-dev.s3.amazonaws.com"

export const IMAGE_URl = (val) => BASE_URL.substr(0, process.env.REACT_APP_PRODUCTION_URL.length - 1) + val;
export const DATE_FORMAT_SERVER = "yyyy-MM-dd";
export const DATE_FORMAT_ONLY_MONTH_AND_DATE = "MM-dd";
export const DATE_FORMAT_DISPLAY = "dd/MM/yyyy";
export const DATE_AND_TIME_FORMAT_DISPLAY = "MMMM dd, yyyy at hh:mm a";

export const ACCESS_TOKEN = "argotec_admin_visitor_access";

export const POPUP_SMALL = "small";
export const POPUP_MEDIUM = "medium";
export const POPUP_LARGE = "large";

export const CUSTOM_TYPE = "custom-link"
export const SAVE_CONTACT = "save-contact";

export const PRIMARY_COLOR = "#4c0788";

export const LISTING_LIMIT = 30;

export const initialPopupState = {
    component: null,
    visible: false,
    size: "small",
    heading: "",
    contained: false,
    hideDefaultClose: false,
    second_component: false
}

export const MAX_CHARS_BIO = 100;
export const SUPPORTED_IMAGES = ["image/png", "image/jpeg", "image/webp"]

export const BOOLEAN_OPTIONS = [
    {
        label: "Yes",
        value: true
    },
    {
        label: "No",
        value: false
    },

]
export const SHIPPING_OPTIONS = [
    {
        label: "Ships Anytime",
        value: "anytime"
    },
    {
        label: "Ships Today",
        value: "today"
    },
    {
        label: "Out of Stock",
        value: "out-of-stock"
    },

]
export const COUPON_CODE_TYPE = [
    {
        label: "Amount",
        value: "amount"
    },
    {
        label: "Percentage",
        value: "percentage"
    },
]
export const ACTIVE_DISABLED_OPTIONS = [
    {
        label: "Active",
        value: true
    },
    {
        label: "Disabled",
        value: false
    },

]
export const REQUEST_OPTIONS = [
    {
        label: "Accept",
        value: "accept"
    },
    {
        label: "Reject",
        value: "reject"
    },
]
export const ROLE_OPTIONS = [
    {
        label: "B2B",
        value: "b2b-user"
    },
    {
        label: "B2C",
        value: "b2c-user"
    },

]

export const FIXED_ATTRIBUTES = [
    {
        label: "XS",
        value: "XS"
    },
    {
        label: "S",
        value: "S"
    },
    {
        label: "M",
        value: "M"
    },
    {
        label: "L",
        value: "L"
    },
    {
        label: "XL",
        value: "xL"
    },
    {
        label: "XXL",
        value: "XXL"
    },

]



// Links use throughout this project
export const LOGIN_URL = "/login"
export const FORGOT_PASSOWORD_URL = "/forgot-password"
export const RESET_PASSOWORD_URL = "/reset-password"
export const PROFILE_URL = "/profile"
export const CATEGORIES_URL = "/categories"

export const COMPANY_LISTING_URL = "/companies"
export const USER_LISTING_URL = "/users"
export const B2B_REQUEST_URL = "/b2b-requests"

export const USER_DETAILS_URL = "/user"
export const SALES_LISTING_URL = "/sales"
export const UPDATE_SALE_URL = "/sales/update"
export const ADD_SALE = "/sale/add"
export const ATTRIBUTES_LISTING_URL = "/attributes"
export const TAX_CLASS_URL = "/tax"
export const ORDER_LISTING_URL = "/orders"
export const ORDER_DETAILS = "/order"
export const COUPON_CODE_LISTING = "/coupon-codes"
export const PRO_CLUB_USERS_LISTING_URL = "/pro-club-users"
export const PRO_CLUB_LEVEL_LISTING_URL = "/pro-club-levels"
export const HOME_PAGE_PRODUCT_LISTING = "/home-page-products"
export const RETURNED_ORDERS = "/returned-orders"
export const EXCHANGE_ORDER = "/exchange-order"
export const PREVIEW_LINK = `${CLIENT_DOMAIN}preview`



export const ADD_NEWS_URL = "/news/add"
export const UPDATE_NEWS_URL = "/news/update"
export const NEWS_DETAIL_URL = "/news"
export const NEWS_LISTING_URL = "/news"
export const ANALYTICS_URL = "/analytics"

export const ADD_PRESS_RELEASE_URL = "/press-release/add"
export const UPDATE_PRESS_RELEASE_URL = "/press-release/update"
export const PRESS_RELEASE_DETAIL_URL = "/press-release/details"
export const PRESS_RELEASE_LISTING_URL = "/press-release"

export const CAREERS_LISTING_LINK = "/careers"
export const CAREERS_ADD_LINK = "/career/add"
export const CAREERS_UPDATE_LINK = "/career/update"

export const CANDIDATE_LISTING_LINK = "/candidates"
export const SPONTANEOUS_CANDIDATE_LISTING_LINK = "/spontaneous-applications"

export const EVENT_LISTING_LINK = "/events"
export const EVENT_ADD_LINK = "/event/add"
export const EVENT_UPDATE_LINK = "/events/update"
export const EVENT_DETAIL_LINK = "/event/"



export const MEDIA_WALL_LINK = "/media-wall"
export const CONTACT_US_LINK = "/contact_us"
export const INDUSTRIAL_ACCELERATOR_LISTING_LINK = "/industrial-accelerator"
export const PRODUCTS_LEADS_LISTING_LINK = "/leads-from-products"
export const BROCHURES_LISTING_URL = "/brochures"


export const DEPARTMENT_LISTING_LINK = "/departments"

export const SPOTLIGHT_LISTING_URL = "/spotlight"
export const ADD_SPOTLIGHT_URL = "/spotlight/add"


export const HAWK = "hawk"
export const HAWK_HEAVY = "hawk-heavy"
export const HAWK_EARTH_OBSERVATION = 'hawk-earth-observation'
export const SUB_SYSTEM_FERMI = 'sub-system-fermi'
export const SUB_SYSTEM_VOLTA = 'sub-system-volta'
export const SUB_SYSTEM_EBC = 'sub-system-ebc'
export const SUB_SYSTEM_ZEUS = 'sub-system-zeus'
export const SUB_SYSTEM_ELEKTRA = 'sub-system-elektra'
export const SUB_SYSTEM_UST_LITE = 'ust-lite'


export const LEADS_FROM_PRODUCTS_OPTIONS = [
    {
        label: "Hawk",
        value: HAWK
    },
    {
        label: "Hawk Plus",
        value: HAWK_EARTH_OBSERVATION
    },
    {
        label: "Hawk Heavy",
        value: HAWK_HEAVY
    },
    {
        label: "Fermi Obc&Dh ",
        value: SUB_SYSTEM_FERMI
    },
    {
        label: "Volta Pcdu",
        value: SUB_SYSTEM_VOLTA
    },
    {
        label: "Ebc",
        value: SUB_SYSTEM_EBC
    },
    {
        label: "Zeus Pcdu",
        value: SUB_SYSTEM_ZEUS
    },
    {
        label: "Elektra",
        value: SUB_SYSTEM_ELEKTRA
    },
    {
        label: "UST LITE",
        value: SUB_SYSTEM_UST_LITE
    },

]
export const BROCHURE_TYPES = [
    {
        label: "Corporate Brochure",
        value: "corporate-brochure"
    },
    {
        label: "Technical Brochure",
        value: "technical-brochure"
    },

]




export const DEFUALT_URL = "/news"
// Links use throughout this project



export const BEST_SELLING = "Best selling"
export const POPULAR = "Popular"
export const RISING = "Rising"


// status
export const ACTIVE = "active"
export const DISABLED = "disabled"
export const NOT_APPROVED = "not-approved"



// 

export const CONFIRMED = "confirmed"
export const SHIPPED = 'shipped'
export const CLOSED = 'closed'
export const PENDING = "pending"
export const CANCELLED = 'cancelled'
export const RETURNED = 'returned'
export const EXCHANGED = 'exchanged'

export const ORDER_STATUS_OPTIONS = [
    { value: CONFIRMED, label: "Confirmed" },
    { value: SHIPPED, label: "Shipped" },
    { value: PENDING, label: "Pending" },
    { value: CLOSED, label: "Closed" },
    { value: CANCELLED, label: "Cancelled" },
    { value: RETURNED, label: "Returned" },
    { value: EXCHANGED, label: "Exchanged" }
]

export const RETURNED_ORDER_STATUS = [
    { value: 1, label: "Pending" },
    { value: 2, label: "Confirmed" },
]


export const CASH_ON_DELIVERY = 'cash-on-delivery'
export const BANK_TRANSFER = 'bank-transfer'


export const SIZE_CONSTANT = "size"
export const COLOR_CONSTANT = "color"
export const TAG_CONSTANT = "tag"
export const REGION_CONSTANT = "region"


export const ATTRIBUTE_TYPE = [
    { value: SIZE_CONSTANT, label: "Size" },
    { value: COLOR_CONSTANT, label: "Color" },
    { value: TAG_CONSTANT, label: "Tag" },
    { value: REGION_CONSTANT, label: "Region" },
]

export const BASIC = "basic"
export const SILVER = "silver"
export const GOLD = "gold"
export const PLANTINUM = "platinum"

export const FILTER_BY_LEVEL = [
    { value: PLANTINUM, label: "Platinium" },
    { value: GOLD, label: "Gold" },
    { value: SILVER, label: "Silver" },
    { value: BASIC, label: "Basic" }
]


export const CUSTOMER_ROLE = 'customer'
export const OPERATOR_ROLE = 'operator'
export const MEMBER_ROLE = 'member'
export const SUPER_ADMIN_ROLE = 'super-admin'


export const GENDER_DROPDOWN = [
    { value: 'Male', label: "Male" },
    { value: 'Female', label: "Female" },
    { value: 'Other', label: "Other" },
]

export const ASSENDING_ORDER = "asc"
export const DESENDING_ORDER = "desc"






export const TYPE_NEWS = "news"
export const TYPE_PRESS_RELEASE = "press-release"
export const TYPE_EVENT = "event"
export const ON_SITE = "on-site"
export const REMOTE = "remote"
export const HYBRID = "hybrid"

export const NEWS_TYPES_OPTIONS = [
    {
        label: "News",
        value: TYPE_NEWS
    },
    {
        label: "Press Release",
        value: TYPE_PRESS_RELEASE
    },

]

export const JOB_TYPE_OPTIONS = [
    {
        label: "Onsite",
        value: ON_SITE
    },
    {
        label: "Remote",
        value: REMOTE
    },
    {
        label: "Hybrid",
        value: HYBRID
    },

]



export const MEDIA_WALL_POSITIONS = [
    {
        label: 1,
        value: 1
    },
    {
        label: 2,
        value: 2
    },
    {
        label: 3,
        value: 3
    },
    {
        label: 4,
        value: 4
    },
    {
        label: 5,
        value: 5
    },
    {
        label: 6,
        value: 6
    }

]

export const SPOTLIGHT_POSITIONS = [
    {
        label: 1,
        value: 1
    },
    {
        label: 2,
        value: 2
    },
    {
        label: 3,
        value: 3
    },
    {
        label: 4,
        value: 4
    },
    {
        label: 5,
        value: 5
    },
]

export const SPOTLIGHT_FILTER_OPTIONS = [
    {
        label: "News",
        value: TYPE_NEWS
    },
    {
        label: "EVENTS",
        value: TYPE_EVENT
    },
    {
        label: "Press Release",
        value: TYPE_PRESS_RELEASE
    }
]

export const FILTER_ALL = { value: "", label: <FormattedMessage id="all" defaultMessage={"All"} /> }

export const DATE_DAILY = {
    value: "day",
    label: <FormattedMessage id="daily" defaultMessage={"Daily"} />,
}
export const DATE_WEEKLY = {
    value: "week",
    label: <FormattedMessage id="weekly" defaultMessage={"Weekly"} />,
}
export const DATE_MONTHLY = {
    value: "month",
    label: <FormattedMessage id="monthly" defaultMessage={"Monthly"} />,
}
export const DATE_YEARLY = {
    value: "year",
    label: <FormattedMessage id="yearly" defaultMessage={"Yearly"} />,
}

export const DATE_FILTER_TYPES = [
    // DATE_DAILY,
    DATE_WEEKLY,
    DATE_MONTHLY,
    DATE_YEARLY
]




export const CITY_KEY_MAP = {
    "San Mauro Torinese (TO) - SpacePark": {
        current: "SPACEPARK_CURRENT_YEAR",
        last: "SPACEPARK_LAST_YEAR",
    },
    "Melbourne FL, USA": {
        current: "MELBOURNE_CURRENT_YEAR",
        last: "MELBOURNE_LAST_YEAR",
    },
    "Los Angeles (CA), USA": {
        current: "LOS_ANGELES_CURRENT_YEAR",
        last: "LOS_ANGELES_LAST_YEAR",
    },
};

export const LOCATION_IDENTIFIERS = {
    USA_LA: "Los Angeles (CA), USA",
    USA_MELBOURNE: "Melbourne FL, USA",
    ITALY_SPACEPARK: "San Mauro Torinese (TO) - SpacePark",
};

export const REGION_MAPPING = {
    US: [LOCATION_IDENTIFIERS.USA_LA, LOCATION_IDENTIFIERS.USA_MELBOURNE],
    ITALY: [LOCATION_IDENTIFIERS.ITALY_SPACEPARK],
};


export const SERIES_COLOR_MAP = {
    "SPACEPARK_CURRENT_YEAR": "#242656", // SpacePark This Year
    "SPACEPARK_LAST_YEAR": "#FF6B6B",    // SpacePark Last Year
    "MELBOURNE_CURRENT_YEAR": "#4ECDC4",       // Melbourne This Year
    "MELBOURNE_LAST_YEAR": "#FFA500",           // Melbourne Last Year
    "LOS_ANGELES_CURRENT_YEAR": "#8B4513", // Los Angeles This Year
    "LOS_ANGELES_LAST_YEAR": "#FFD700"   // Los Angeles Last Year
};


export const unslugify = (str, preserveAcronyms = true) => {
    if (!str) return "";

    return str
        .split("_")
        .map(word => {
            if (preserveAcronyms && word === word.toUpperCase() && word.length > 1) {
                return word; // keep acronym fully uppercase
            }
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join(" ");
};